const questionType = require('../../../questionType');
const productType = require('../../../productType');
const SKILanguages = require('../../../SKILanguages');
const journeysSchema = require('../../../../public/assets/src/scripts/data/journeys.json');

const REGEXP = {
	UUID_V4: /^[0-9A-F]{8}-[0-9A-F]{4}-[45][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i
};

function toTruthMap() {
	var map = {};

	Array.prototype.forEach.call(arguments, function (i) {
		map[i] = true;
	});

	return map;
}

function values(o, blacklist) {
	var v = [];

	for (var key in o) {
		if (!blacklist || !(key in blacklist)) {
			v.push(o[key]);
		}
	}

	return v;
}

const SKILanguagesTruthMap = toTruthMap(...Object.keys(SKILanguages));
const journeysTruthMap = toTruthMap(...Object.keys(journeysSchema));

module.exports = {
	validation: {
		max: 4000
	},
	services: {
		library: {
			getResultsByClass: {
				method: 'get',
				secure: 'teacher',
				spec: {
					cc: {
						type: 'string',
						required: true
					},
					d: {
						type: 'number',
						required: true
					},
					ed: {
						type: 'number',
						required: true
					}
				}
			},
			studentGetAnnotations: {
				method: 'get',
				secure: 'library',
				spec: {
					p: {
						type: 'string',
						required: true
					}
				}
			},
			updateAnnotation: {
				method: 'put',
				secure: 'library',
				spec: {
					p: {
						type: 'string',
						required: true
					},
					hid: {
						type: 'string',
						required: true
					},
					hn: {
						type: 'string'
					},
					hs: {
						type: 'string'
					}
				}
			},
			createAnnotation: {
				method: 'post',
				secure: 'library',
				spec: {
					p: {
						type: 'string',
						required: true
					},
					hn: {
						type: 'string'
					},
					hs: {
						type: 'string',
						required: true
					},
					hrs: {
						type: 'string',
						required: true
					},
					hre: {
						type: 'string',
						required: true
					}
				}
			},
			deleteAnnotation: {
				method: 'delete',
				secure: 'library',
				spec: {
					p: {
						type: 'string',
						required: true
					},
					hid: {
						type: 'string',
						required: true
					}
				}
			},
			getStudentSettings: {
				method: 'get',
				secure: 'library'
			},
			setStudentSettings: {
				method: 'post',
				secure: 'libary',
				spec: {
					t: {
						type: 'string',
						domain: toTruthMap('space', 'back-to-school', 'global', 'grape', 'green', 'flow')
					},
					g: {
						type: 'object',
						freeform: true
					},
					skf: {
						type: 'object',
						freeform: true
					}
				}
			},
			submitArticleNote: {
				method: 'put',
				secure: 'library',
				spec: {
					p: {
						type: 'string',
						required: true
					},
					n: {
						type: 'string',
						required: true
					}
				}
			},
			readArticle: {
				method: 'post',
				secure: 'library',
				spec: {
					p: {
						type: 'string',
						required: true
					},
					n: {
						type: 'string'
					},
					g: {
						type: 'number',
						required: true,
						domain: toTruthMap(16, 17, 18, 19, 20, 21, 22, 323, 343, 346, 347, 191923, 192000)
					}
				}
			},
			studentGetArticlesRead: {
				method: 'get',
				secure: 'library'
			},
			teacherGetArticlesRead: {
				method: 'get',
				secure: 'teacher',
				spec: {
					cc: {
						type: 'string',
						required: true
					},
					uid: {
						type: 'string',
						required: true
					}
				}
			},
			readingListAdd: {
				method: 'post',
				secure: 'library',
				spec: {
					p: {
						type: 'string',
						required: true
					}
				}
			},
			readingListRemove: {
				method: 'delete',
				secure: 'library',
				spec: {
					p: {
						type: 'string',
						required: true
					}
				}
			},
			getReadingList: {
				method: 'get',
				secure: 'library'
			},
			favoritesAdd: {
				method: 'post',
				secure: 'library',
				spec: {
					p: {
						type: 'string',
						required: true
					}
				}
			},
			favoritesRemove: {
				method: 'delete',
				secure: 'library',
				spec: {
					p: {
						type: 'string',
						required: true
					}
				}
			},
			getFavorites: {
				method: 'get',
				secure: 'library'
			}
		},
		recommendation: {
			studentLibrarySimilar: {
				method: 'get',
				secure: 'library'
			},
			studentLibraryCollaborativeRead: {
				method: 'get',
				secure: 'library',
				spec: {
					g: {
						type: 'number',
						required: true,
						domain: toTruthMap(16, 17, 18, 19, 20, 21, 22, 323, 343, 346, 347, 191923, 192000)
					}
				}
			}
		},
		login: {
			clever: {
				method: 'get',
				secure: false
			}
		},
		discovery: {
			getClassRecommendations: {
				method: 'get',
				secure: 'teacher',
				spec: {
					cc: {
						type: 'string',
						required: true
					}
				}
			},
			libraryReadNext: {
				method: 'get',
				secure: 'library',
				spec: {
					pid: {
						type: 'string',
						required: true
					},
					pt: {
						type: 'string',
						required: true,
						domain: toTruthMap(productType.article, productType.pairedText, productType.articleADay)
					},
					g: {
						type: 'string',
						required: true,
						domain: toTruthMap(16, 17, 18, 19, 20, 21, 22, 323, 343, 346, 347, 191923, 192000)
					},
					exclusion: {
						type: 'string'
					}
				}
			},
			getLibraryProductsByGenre: {
				method: 'get',
				secure: true,
				spec: {
					genre: {
						type: 'string',
						required: true
					},
					g: {
						type: 'number',
						required: true,
						domain: toTruthMap(16, 17, 18, 19, 20, 21, 22, 323, 343, 346, 347, 191923, 192000)
					}
				}
			},
			getLibraryProductsBySKF: {
				method: 'get',
				secure: true,
				spec: {
					skf: {
						type: 'string',
						required: true
					},
					g: {
						type: 'number',
						required: true,
						domain: toTruthMap(16, 17, 18, 19, 20, 21, 22, 323, 343, 346, 347, 191923, 192000)
					}
				}
			},
			searchLibrary: {
				method: 'get',
				secure: true,
				spec: {
					f: {
						type: 'number'
					},
					q: {
						type: 'string',
						min: 1,
						max: 1024
					},
					t: {
						type: 'array'
					},
					features: {
						type: 'array'
					},
					g: {
						type: 'number',
						required: true,
						domain: toTruthMap(16, 17, 18, 19, 20, 21, 22, 323, 343, 346, 347, 191923, 192000)
					}
				}
			},
			getNewLibraryProducts: {
				method: 'get',
				secure: true,
				spec: {
					g: {
						type: 'number',
						required: true,
						domain: toTruthMap(16, 17, 18, 19, 20, 21, 22, 323, 343, 346, 347, 191923, 192000)
					}
				}
			},
			getPopularLibraryProducts: {
				method: 'get',
				secure: true,
				spec: {
					g: {
						type: 'number',
						required: true,
						domain: toTruthMap(16, 17, 18, 19, 20, 21, 22, 323, 343, 346, 347, 191923, 192000)
					}
				}
			},
			searchProduct: {
				method: 'get',
				secure: false,
				spec: {
					pt: {
						type: 'array',
						domain: toTruthMap(productType.article, productType.pairedText, productType.articleADay, productType.textSet)
					},
					features: {
						type: 'array',
						domain: toTruthMap(
							'au',
							'ebook',
							'ell',
							'hau',
							'qsmo',
							'qswo',
							'qsmw',
							'va',
							'video',
							'challenge_texts',
							'support_texts',
							'decodable_teacher_editions'
						)
					},
					at: {
						type: 'array'
					},
					sr: {
						type: 'boolean'
					},
					d: {
						type: 'string'
					},
					pids: {
						type: 'string',
						min: 32
					},
					q: {
						type: 'string',
						min: 1,
						max: 1024
					},
					k: {
						type: 'array'
					},
					s: {
						type: 'array'
					},
					t: {
						type: 'array'
					},
					l: {
						type: 'array',
						domain: toTruthMap(
							0,
							50,
							100,
							150,
							200,
							250,
							300,
							350,
							400,
							450,
							500,
							550,
							600,
							650,
							700,
							750,
							800,
							850,
							900,
							950,
							1000,
							1050,
							1100,
							1150,
							1200,
							1250,
							1300,
							1350,
							1400,
							1450,
							1500,
							1550,
							1600,
							1650,
							1700,
							1750,
							1800,
							1850,
							1900,
							1950,
							2000,
							2050,
							2100,
							2150,
							2200
						)
					},
					g: {
						type: 'array',
						domain: toTruthMap(16, 17, 18, 19, 20, 21, 22, 323, 343, 346, 347, 191923, 192000)
					},
					a: {
						type: 'array',
						min: 1,
						max: 5
					},
					lc: {
						type: 'array',
						domain: toTruthMap('BR', 'NP')
					},
					n: {
						type: 'number'
					},
					f: {
						type: 'number'
					},
					cn: {
						type: 'string'
					},
					cid: {
						type: 'array'
					},
					staff_picks: {
						type: 'array'
					},
					sel: {
						type: 'array'
					},
					tag: {
						type: 'array'
					},
					soft: {
						type: 'boolean'
					},
					subType: {
						type: 'array',
						domain: toTruthMap(7000, 8000, 8001)
					},
					book: {
						type: 'number'
					},
					wc: {
						type: 'array',
						domain: toTruthMap(
							0,
							50,
							100,
							150,
							200,
							250,
							300,
							350,
							400,
							450,
							500,
							550,
							600,
							650,
							700,
							750,
							800,
							850,
							900,
							950,
							1000,
							1050,
							1100,
							1150,
							1200,
							1250,
							1300,
							1350,
							1400,
							1450,
							1500,
							1550,
							1600,
							1650,
							1700,
							1750,
							1800,
							1850,
							1900,
							1950,
							2000,
							2050,
							2100,
							2150,
							2200,
							2250,
							2300,
							2350,
							2400,
							2450,
							2500,
							2550,
							2600,
							2650,
							2700,
							2750,
							2800,
							2850,
							2900,
							2950,
							3000
						)
					},
					series: {
						type: 'array'
					},
					exclusions: {
						type: 'object',
						freeform: true
					}
				}
			},
			searchSchool: {
				method: 'get',
				secure: 'teacher',
				fields: toTruthMap('zip'),
				reqFields: toTruthMap('zip'),
				specMap: 'discovery'
			},
			findSimilars: {
				method: 'get',
				secure: false,
				fields: toTruthMap('q', 'pt', 'pids', 'n', 'subType', 'g', 'exclusions', 'book'),
				reqFields: toTruthMap('q'),
				specMap: 'discovery'
			}
		},
		class: {
			addToClassBoK: {
				method: 'post',
				secure: 'teacher',
				spec: {
					aid: {
						type: 'string',
						regexp: REGEXP.UUID_V4,
						required: true
					},
					cc: {
						type: 'string',
						required: true
					},
					a: {
						type: 'string',
						required: true
					},
					uid: {
						type: 'string',
						regexp: REGEXP.UUID_V4,
						required: true
					}
				}
			},
			removeFromClassBoK: {
				method: 'delete',
				secure: 'teacher',
				spec: {
					aid: {
						type: 'string',
						regexp: REGEXP.UUID_V4,
						required: true
					},
					cc: {
						type: 'string',
						required: true
					},
					a: {
						type: 'string',
						required: true
					},
					uid: {
						type: 'string',
						regexp: REGEXP.UUID_V4,
						required: true
					}
				}
			},
			getClassBoKEntries: {
				method: 'get',
				secure: true,
				spec: {
					cc: {
						type: 'string'
					},
					aid: {
						type: 'string',
						regexp: REGEXP.UUID_V4
					},
					uid: {
						type: 'string'
					}
				}
			},
			getGroups: {
				method: 'get',
				secure: 'teacher',
				spec: {
					cc: {
						type: 'string',
						required: true
					}
				}
			},
			createStudentGroup: {
				method: 'post',
				secure: 'teacher',
				spec: {
					cc: {
						type: 'string',
						required: true
					},
					n: {
						type: 'string',
						required: true
					},
					suids: {
						type: 'object',
						freeform: true
					}
				}
			},
			renameStudentGroup: {
				method: 'put',
				secure: 'teacher',
				spec: {
					id: {
						type: 'string',
						required: true
					},
					cc: {
						type: 'string',
						required: true
					},
					n: {
						type: 'string',
						required: true
					}
				}
			},
			removeStudentsFromGroup: {
				method: 'put',
				secure: 'teacher',
				spec: {
					id: {
						type: 'string',
						required: true
					},
					cc: {
						type: 'string',
						required: true
					},
					suids: {
						type: 'object',
						required: true,
						freeform: true
					},
					token: {
						type: 'string'
					}
				}
			},
			addStudentsToGroup: {
				method: 'put',
				secure: 'teacher',
				spec: {
					id: {
						type: 'string',
						required: true
					},
					cc: {
						type: 'string',
						required: true
					},
					suids: {
						type: 'object',
						required: true,
						freeform: true
					},
					token: {
						type: 'string'
					}
				}
			},
			getGroup: {
				method: 'get',
				secure: 'teacher',
				spec: {
					id: {
						type: 'string',
						required: true
					},
					cc: {
						type: 'string',
						required: true
					}
				}
			},
			deleteGroup: {
				method: 'delete',
				secure: 'teacher',
				spec: {
					id: {
						type: 'string',
						required: true
					},
					cc: {
						type: 'string',
						required: true
					}
				}
			},
			synchronizeGoogleClassroomRoster: {
				method: 'put',
				secure: 'teacher',
				spec: {
					cc: {
						type: 'string',
						required: true
					},
					token: {
						type: 'string',
						required: true
					}
				}
			},
			getPendingCoteachers: {
				method: 'get',
				secure: 'teacher',
				spec: {
					cc: {
						type: 'string',
						required: true
					}
				}
			},
			assignmentSettings: {
				method: 'put',
				secure: 'teacher',
				spec: {
					cc: {
						type: 'string',
						required: true
					},
					dcp: {
						type: 'boolean'
					},
					gcp: {
						type: 'boolean'
					},
					bokEdit: {
						type: 'boolean'
					},
					showResults: {
						type: 'boolean'
					},
					goals: {
						type: 'array'
					},
					library: {
						type: 'boolean'
					},
					assignmentHideLibrary: {
						type: 'boolean'
					}
				}
			},
			lockClass: {
				method: 'put',
				secure: 'teacher',
				spec: {
					cc: {
						required: true,
						type: 'string'
					}
				}
			},
			unlockClass: {
				method: 'put',
				secure: 'teacher',
				spec: {
					cc: {
						required: true,
						type: 'string'
					}
				}
			},
			getCoteachers: {
				method: 'get',
				secure: 'teacher',
				fields: toTruthMap('cc'),
				reqFields: toTruthMap('cc'),
				specMap: 'classes'
			},
			addCoteacher: {
				method: 'post',
				secure: 'teacher',
				fields: toTruthMap('cc', 'e'),
				reqFields: toTruthMap('cc', 'e'),
				specMap: 'classes'
			},
			confirmCoteacher: {
				method: 'get',
				secure: false,
				spec: {
					token: {
						required: true,
						type: 'string'
					}
				}
			},
			declineCoteacherInvite: {
				method: 'delete',
				secure: false,
				spec: {
					t: {
						required: true,
						type: 'string'
					}
				}
			},
			getCoteacherInvites: {
				method: 'get',
				secure: 'teacher'
			},
			removeCoteacher: {
				method: 'delete',
				secure: 'teacher',
				fields: toTruthMap('cc', 'uid'),
				reqFields: toTruthMap('cc', 'uid'),
				specMap: 'classes'
			},
			coteacherLeaveClass: {
				method: 'delete',
				secure: 'teacher',
				fields: toTruthMap('cc'),
				reqFields: toTruthMap('cc'),
				specMap: 'classes'
			},
			getBigBookOfKnowledge: {
				method: 'get',
				secure: true,
				spec: {
					cc: {
						type: 'string'
					},
					uid: {
						type: 'string'
					},
					d: {
						required: true,
						type: 'number'
					},
					ed: {
						required: true,
						type: 'number'
					}
				}
			},
			getClassSummaryByAssignment: {
				method: 'get',
				secure: 'teacher',
				fields: toTruthMap('cc', 'd', 'ed'),
				reqFields: toTruthMap('cc', 'd', 'ed'),
				specMap: 'classes'
			},
			listGoogleClassroomClasses: {
				method: 'get',
				secure: 'teacher',
				spec: {
					token: {
						type: 'string',
						required: true
					}
				}
			},
			createClassFromGoogleClassroom: {
				method: 'post',
				secure: 'teacher',
				spec: {
					token: {
						type: 'string',
						required: true
					},
					gcid: {
						type: 'string',
						required: true
					},
					g: {
						type: 'string',
						required: true
					}
				}
			},
			updateClass: {
				method: 'put',
				secure: 'teacher',
				spec: {
					cc: {
						type: 'string',
						required: true
					},
					n: {
						type: 'string'
					},
					s: {
						type: 'string'
					},
					gcid: {
						type: 'string'
					},
					token: {
						type: 'string'
					}
				}
			},
			getClasses: {
				method: 'get',
				secure: 'teacher'
			},
			checkClass: {
				method: 'get',
				secure: false,
				spec: {
					cc: {
						type: 'string',
						required: true,
						min: 6,
						max: 6
					}
				}
			},
			getStudents: {
				method: 'get',
				secure: false,
				fields: toTruthMap('cc'),
				reqFields: toTruthMap('cc'),
				specMap: 'classes'
			},
			unEnrollStudent: {
				method: 'delete',
				secure: 'teacher',
				spec: {
					uid: {
						type: 'string',
						required: true
					},
					cc: {
						type: 'string',
						required: true
					}
				}
			},
			getClassesFromGoogleToken: {
				method: 'get',
				fields: {
					token: true
				},
				specMap: 'classes'
			},
			getClassesFromCleverToken: {
				method: 'get',
				spec: {
					token: {
						type: 'string'
					}
				}
			},
			createClass: {
				method: 'post',
				secure: 'teacher',
				fields: toTruthMap('n', 'g', 'rt'),
				reqFields: toTruthMap('n', 'g', 'rt'),
				specMap: 'classes'
			},
			getClassRoster: {
				method: 'get',
				secure: 'teacher',
				fields: toTruthMap('cc'),
				reqFields: toTruthMap('cc'),
				specMap: 'classes'
			}
		},
		test: {
			resetDB: {
				method: 'post'
			},
			generateData: {
				method: 'post',
				spec: {
					accounts: {
						type: 'object',
						freeform: true
					},
					classes: {
						type: 'object',
						freeform: true
					},
					assignments: {
						type: 'object',
						freeform: true
					},
					researchAssessments: {
						type: 'object',
						freeform: true
					}
				}
			}
		},
		admin: {
			cleanup: {
				method: 'post',
				secure: 'admin'
			},
			diagnostic: {
				method: 'post'
			}
		},
		analytix: {
			events: {
				method: 'post',
				secure: false,
				fields: toTruthMap('events'),
				reqFields: toTruthMap('events'),
				specMap: 'analytics'
			},
			error: {
				method: 'post',
				secure: false,
				spec: {
					error: {
						type: 'object',
						freeform: true,
						required: true
					},
					code: {
						type: 'string',
						required: true
					}
				}
			},
			activeCampaignEvents: {
				method: 'post',
				secure: 'teacher',
				spec: {
					event: {
						type: 'string',
						required: true,
						domain: toTruthMap('print', 'project', 'aad', 'assignAADSSvocab', 'assignAADSStopical')
					}
				}
			},
			timestamp: {
				method: 'get',
				secure: false
			}
		},
		assignment: {
			completeVocabActivity: {
				secure: 'student',
				method: 'put',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					type: {
						type: 'string',
						required: true,
						domain: toTruthMap('wb', 'wc', 'wm')
					}
				}
			},
			rateTheWord: {
				secure: 'student',
				method: 'put',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					type: {
						type: 'string',
						required: true,
						domain: toTruthMap('pre', 'post')
					},
					word: {
						type: 'string',
						required: true
					},
					rating: {
						type: 'number',
						required: true
					}
				}
			},
			getNewGradedAssignments: {
				secure: 'student',
				method: 'get',
				spec: {
					cc: {
						type: 'string',
						required: true
					}
				}
			},
			viewGradedAssignment: {
				secure: 'student',
				method: 'put',
				spec: {
					aid: {
						type: 'string',
						required: true
					}
				}
			},
			readGraphicOrganizer: {
				secure: true,
				method: 'get',
				spec: {
					aid: {
						type: 'string',
						required: true
					}
				}
			},
			createGraphicOrganizerNode: {
				secure: true,
				method: 'post',
				spec: {
					aid: {
						type: 'string',
						required: true
					},
					p: {
						type: 'string'
					},
					w: {
						type: 'string'
					},
					t: {
						type: 'string'
					},
					l: {
						type: 'string'
					}
				}
			},
			updateGraphicOrganizerNode: {
				secure: true,
				method: 'put',
				spec: {
					aid: {
						type: 'string',
						required: true
					},
					nid: {
						type: 'string',
						required: true
					},
					p: {
						type: 'string'
					},
					w: {
						type: 'string'
					},
					t: {
						type: 'string'
					},
					l: {
						type: 'string'
					}
				}
			},
			deleteGraphicOrganizerNode: {
				secure: true,
				method: 'delete',
				spec: {
					aid: {
						type: 'string',
						required: true
					},
					nid: {
						type: 'string',
						required: true
					}
				}
			},
			getReadingMindsetSnapshotResults: {
				secure: 'teacher',
				method: 'get',
				spec: {
					cc: {
						type: 'string',
						required: true
					},
					rmsid: {
						type: 'string',
						required: true
					}
				}
			},
			editReadingMindsetSnapshotAssignment: {
				secure: 'teacher',
				method: 'put',
				spec: {
					cc: {
						type: 'string',
						required: true
					},
					d: {
						type: 'number',
						required: true
					},
					rmsid: {
						type: 'string',
						required: true
					},
					token: {
						type: 'string'
					}
				}
			},
			createReadingMindsetSnapshotAssignment: {
				secure: 'teacher',
				method: 'post',
				spec: {
					cc: {
						type: 'string',
						required: true
					},
					d: {
						type: 'number',
						required: true
					},
					gc: {
						type: 'boolean'
					},
					token: {
						type: 'string'
					}
				}
			},
			deleteReadingMindsetSnapshotAssignment: {
				secure: 'teacher',
				method: 'delete',
				spec: {
					cc: {
						type: 'string',
						required: true
					},
					rmsid: {
						type: 'string',
						required: true
					},
					token: {
						type: 'string'
					}
				}
			},
			endReadingMindsetSnapshotAssignment: {
				secure: 'teacher',
				method: 'delete',
				spec: {
					cc: {
						type: 'string',
						required: true
					},
					rmsid: {
						type: 'string',
						required: true
					},
					token: {
						type: 'string'
					}
				}
			},
			getReadingMindsetSnapshotAssignments: {
				secure: 'teacher',
				method: 'get',
				spec: {
					cc: {
						type: 'string',
						required: true
					}
				}
			},
			studentSubmitReadingMindsetSnapshotAssignment: {
				secure: 'student',
				method: 'post',
				spec: {
					ans: {
						type: 'object',
						required: true,
						freeform: true
					},
					l: {
						type: 'string',
						required: false,
						domain: SKILanguagesTruthMap
					},
					rmsid: {
						type: 'string',
						required: true
					},
					token: {
						type: 'string'
					}
				}
			},
			studentGetReadingMindsetSnapshotAssignment: {
				secure: 'student',
				method: 'get'
			},
			studentGetReadingMindsetSnapshotWorkspace: {
				secure: 'student',
				method: 'get'
			},
			createTeacherBookOfKnowledge: {
				secure: 'teacher',
				method: 'post',
				spec: {
					aid: {
						type: 'string',
						regexp: REGEXP.UUID_V4,
						required: true
					},
					pid: {
						type: 'string',
						required: true
					},
					bok: {
						type: 'string',
						required: true
					},
					suids: {
						type: 'object',
						freeform: true
					}
				}
			},
			editTeacherBookOfKnowledge: {
				secure: 'teacher',
				method: 'put',
				spec: {
					id: {
						type: 'string',
						required: true
					},
					aid: {
						type: 'string',
						regexp: REGEXP.UUID_V4,
						required: true
					},
					pid: {
						type: 'string',
						required: true
					},
					bok: {
						type: 'string',
						required: true
					},
					suids: {
						type: 'object',
						freeform: true
					}
				}
			},
			deleteTeacherBookOfKnowledge: {
				secure: 'teacher',
				method: 'delete',
				spec: {
					id: {
						type: 'string',
						required: true
					},
					aid: {
						type: 'string',
						required: true
					},
					pid: {
						type: 'string',
						required: true
					}
				}
			},
			getTeacherBookOfKnowledge: {
				secure: 'teacher',
				method: 'get',
				spec: {
					aid: {
						type: 'string',
						required: true
					}
				}
			},
			getBokForAssignment: {
				secure: 'teacher',
				method: 'get',
				spec: {
					aid: {
						type: 'string',
						required: true
					}
				}
			},
			getCvaProduct: {
				method: 'get',
				secure: 'student'
			},
			getReadingMindsetSnapshotProduct: {
				method: 'get',
				secure: true,
				spec: {
					l: {
						type: 'string',
						required: false,
						domain: SKILanguagesTruthMap
					}
				}
			},
			createCvaAssignment: {
				method: 'post',
				secure: 'teacher',
				spec: {
					cc: {
						type: 'string',
						required: true,
						min: 6,
						max: 6
					},
					d: {
						type: 'number',
						required: true
					},
					group: {
						type: 'string',
						required: true,
						domain: toTruthMap('A', 'B')
					}
				}
			},
			getCVAEligibleClasses: {
				method: 'get',
				secure: 'teacher'
			},
			deleteCvaAssignment: {
				method: 'delete',
				secure: 'teacher',
				reqFields: toTruthMap('cc'),
				fields: toTruthMap('cc'),
				specMap: 'classes'
			},
			teacherGetCvaAssignments: {
				method: 'get',
				secure: 'teacher'
			},
			studentSubmitCvaAssignment: {
				method: 'post',
				secure: 'student',
				reqFields: toTruthMap('ans'),
				fields: toTruthMap('ans'),
				specMap: 'assignments'
			},
			studentGetCvaAssignment: {
				method: 'get',
				secure: 'student'
			},
			getStudentResearchAssessments: {
				method: 'get',
				secure: 'student'
			},
			teacherGetStudentResearchAssessments: {
				method: 'get',
				secure: 'teacher',
				spec: {
					cc: {
						type: 'string',
						required: true
					}
				}
			},
			getStudentResearchAssessmentProduct: {
				method: 'get',
				secure: 'student',
				reqFields: toTruthMap('type'),
				fields: toTruthMap('type'),
				spec: {
					type: {
						type: 'string',
						required: true
					}
				}
			},
			submitStudentResearchAssessment: {
				method: 'post',
				secure: 'student',
				reqFields: toTruthMap('answers', 'sraid'),
				fields: toTruthMap('answers', 'sraid'),
				spec: {
					answers: {
						type: 'object',
						required: true,
						freeform: true
					},
					sraid: {
						type: 'string',
						required: true
					}
				}
			},
			teacherGetSingleStudentAssignmentResults: {
				method: 'get',
				secure: true,
				reqFields: toTruthMap('aid', 'uid', 'cc'),
				fields: toTruthMap('aid', 'uid', 'cc'),
				specMap: 'classes'
			},
			teacherUpdateAssignment: {
				method: 'put',
				secure: 'teacher',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					cc: {
						type: 'string',
						required: true
					},
					as: {
						type: 'string',
						required: true
					},
					token: {
						type: 'string'
					},
					shwres: {
						type: 'boolean'
					}
				}
			},
			teacherGetAssignments: {
				method: 'get',
				secure: 'teacher',
				fields: toTruthMap('cc'),
				reqFields: toTruthMap('cc'),
				specMap: 'classes'
			},
			teacherGetDetailedAssignmentResults: {
				method: 'get',
				secure: 'teacher',
				fields: toTruthMap('aid', 'cc', 'qsid'),
				reqFields: toTruthMap('aid', 'cc', 'qsid'),
				specMap: 'classes'
			},
			teacherGradeQuestion: {
				method: 'put',
				secure: 'teacher',
				fields: toTruthMap('uid', 'aid', 'tgrade', 'token', 'gc'),
				reqFields: toTruthMap('uid', 'aid', 'tgrade'),
				specMap: 'classes'
			},
			studentGetClassAssignments: {
				method: 'get',
				secure: 'student'
			},
			assignmentExists: {
				method: 'get',
				secure: 'teacher',
				fields: toTruthMap('pid', 'cc'),
				reqFields: toTruthMap('pid', 'cc'),
				specMap: 'classes'
			},
			teacherGetAssignmentResultsSummary: {
				method: 'get',
				secure: 'teacher',
				fields: toTruthMap('aid', 'cc'),
				reqFields: toTruthMap('aid', 'cc'),
				specMap: 'classes'
			},
			teacherGetAnnotations: {
				method: 'get',
				secure: 'teacher',
				fields: toTruthMap('aid', 'uid'),
				reqFields: toTruthMap('aid', 'uid'),
				specMap: 'classes'
			},
			studentGetAnnotations: {
				method: 'get',
				secure: 'student',
				fields: toTruthMap('aid', 'pid'),
				reqFields: toTruthMap('aid', 'pid'),
				specMap: 'classes'
			},
			updateAnnotation: {
				method: 'put',
				secure: 'student',
				fields: toTruthMap('aid', 'pid', 'hid', 'hn', 'hs'),
				reqFields: toTruthMap('aid', 'pid', 'hid'),
				specMap: 'classes'
			},
			createAnnotation: {
				method: 'post',
				secure: 'student',
				fields: toTruthMap('aid', 'pid', 'hn', 'hs', 'hrs', 'hre'),
				reqFields: toTruthMap('aid', 'pid', 'hs', 'hrs', 'hre'),
				specMap: 'classes'
			},
			deleteAnnotation: {
				method: 'delete',
				secure: 'student',
				fields: toTruthMap('aid', 'pid', 'hid'),
				reqFields: toTruthMap('aid', 'pid', 'hid'),
				specMap: 'classes'
			},
			reviseAssignment: {
				method: 'put',
				secure: 'teacher',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					uid: {
						type: 'string',
						required: true
					},
					edd: {
						type: 'number'
					},
					token: {
						type: 'string'
					}
				}
			},
			redoAssignment: {
				method: 'put',
				secure: 'teacher',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					uid: {
						type: 'string',
						required: true
					},
					edd: {
						type: 'number'
					},
					token: {
						type: 'string'
					}
				}
			},
			getProduct: {
				method: 'get',
				secure: false,
				fields: toTruthMap('id', 'source'),
				reqFields: toTruthMap('id', 'source'),
				specMap: 'product'
			},
			studentOpenWorkspace: {
				method: 'get',
				secure: 'student',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					}
				}
			},
			studentSubmitAssignment: {
				method: 'post',
				secure: 'student',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					token: {
						type: 'string'
					}
				}
			},
			studentAnswerQuestion: {
				method: 'put',
				secure: 'student',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					ans: {
						type: 'object',
						required: true
					},
					'ans.aid': {
						type: 'string',
						required: false
					},
					'ans.t': {
						type: 'string',
						required: false
					},
					'ans.qt': {
						type: 'string',
						required: true,
						domain: toTruthMap.apply(
							this,
							values(questionType, {
								EXTERNAL_ACTIVITY: true
							})
						)
					},
					'ans.p': {
						type: 'string',
						required: false
					},
					'ans.qsid': {
						type: 'string',
						required: true
					},
					'ans.qid': {
						type: 'string',
						required: true
					}
				}
			},
			createAssignment: {
				method: 'post',
				secure: 'teacher',
				spec: {
					g: {
						type: 'string'
					},
					p: {
						type: 'string',
						required: true
					},
					cc: {
						type: 'string',
						required: true
					},
					suids: {
						type: 'array'
					},
					opts: {
						type: 'object',
						required: true
					},
					'opts.a': {
						type: 'boolean'
					},
					'opts.v': {
						type: 'array'
					},
					'opts.va': {
						type: 'array'
					},
					'opts.h': {
						type: 'boolean'
					},
					'opts.qs': {
						type: 'array'
					},
					'opts.expressqs': {
						type: 'array'
					},
					'opts.sr': {
						type: 'array'
					},
					'opts.au': {
						type: 'boolean'
					},
					'opts.ebook': {
						type: 'boolean'
					},
					'opts.bok': {
						type: 'boolean'
					},
					'opts.ell': {
						type: 'boolean'
					},
					'opts.video': {
						type: 'boolean'
					},
					'opts.challenge': {
						type: 'boolean'
					},
					'opts.support': {
						type: 'boolean'
					},
					'opts.wd': {
						type: 'boolean'
					},
					'opts.mm': {
						type: 'boolean'
					},
					'opts.decodables': {
						type: 'array'
					},
					shwres: {
						type: 'boolean'
					},
					d: {
						type: 'number'
					},
					ed: {
						type: 'number'
					},
					m: {
						type: 'string'
					},
					edd: {
						type: 'number'
					},
					gc: {
						type: 'boolean'
					},
					token: {
						type: 'string'
					},
					ss: {
						type: 'boolean'
					},
					ssp: {
						type: 'string'
					},
					ts: {
						type: 'object'
					},
					'ts.pid': {
						type: 'string'
					},
					'ts.title': {
						type: 'string'
					},
					'ts.subType': {
						type: 'number'
					},
					'ts.category': {
						type: 'string'
					},
					'ts.book': {
						type: 'number'
					},
					gcAddon: {
						type: 'object'
					},
					'gcAddon.itemId': {
						type: 'string'
					},
					'gcAddon.addOnToken': {
						type: 'string'
					}
				}
			},
			updateFutureAssignment: {
				method: 'put',
				secure: 'teacher',
				spec: {
					g: {
						type: 'string'
					},
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					cc: {
						type: 'string',
						required: true
					},
					ccc: {
						type: 'string'
					},
					p: {
						type: 'string'
					},
					suids: {
						type: 'array'
					},
					opts: {
						type: 'object'
					},
					'opts.a': {
						type: 'boolean'
					},
					'opts.v': {
						type: 'array'
					},
					'opts.va': {
						type: 'array'
					},
					'opts.h': {
						type: 'boolean'
					},
					'opts.qs': {
						type: 'array'
					},
					'opts.expressqs': {
						type: 'array'
					},
					'opts.sr': {
						type: 'array'
					},
					'opts.au': {
						type: 'boolean'
					},
					'opts.ebook': {
						type: 'boolean'
					},
					'opts.bok': {
						type: 'boolean'
					},
					'opts.ell': {
						type: 'boolean'
					},
					'opts.video': {
						type: 'boolean'
					},
					'opts.challenge': {
						type: 'boolean'
					},
					'opts.support': {
						type: 'boolean'
					},
					'opts.wd': {
						type: 'boolean'
					},
					'opts.mm': {
						type: 'boolean'
					},
					'opts.decodables': {
						type: 'array'
					},
					d: {
						type: 'number'
					},
					ed: {
						type: 'number'
					},
					m: {
						type: 'string'
					},
					edd: {
						type: 'number'
					},
					token: {
						type: 'string'
					},
					shwres: {
						type: 'boolean'
					}
				}
			},
			updateAssignmentDeadline: {
				method: 'put',
				secure: 'teacher',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					cc: {
						type: 'string',
						required: true
					},
					ed: {
						type: 'number'
					},
					edd: {
						type: 'number'
					},
					token: {
						type: 'string'
					}
				}
			},
			finishStudentArticle: {
				method: 'post',
				secure: 'student',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					pid: {
						type: 'string',
						required: true
					},
					bok: {
						type: 'string'
					},
					token: {
						type: 'string'
					}
				}
			},
			saveBookOfKnowledge: {
				method: 'post',
				secure: 'student',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					pid: {
						type: 'string',
						required: true
					},
					bok: {
						type: 'string',
						required: true
					}
				}
			},
			reviseBookOfKnowledge: {
				method: 'post',
				secure: 'student',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					pid: {
						type: 'string',
						required: true
					},
					bok: {
						type: 'string',
						required: true
					}
				}
			},
			editBookOfKnowledge: {
				method: 'put',
				secure: 'student',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					pid: {
						type: 'string',
						required: true
					},
					bok: {
						type: 'string',
						required: true
					}
				}
			},
			setBoKNote: {
				method: 'put',
				secure: 'teacher',
				spec: {
					aid: {
						type: 'string',
						regexp: REGEXP.UUID_V4,
						required: true
					},
					a: {
						type: 'string',
						required: true
					},
					uid: {
						type: 'string',
						regexp: REGEXP.UUID_V4,
						required: true
					},
					tn: {
						type: 'string',
						required: true
					}
				}
			},
			giveAnswerFeedback: {
				method: 'put',
				secure: 'teacher',
				fields: toTruthMap('aid', 'uid', 'qsid', 'qid', 'f'),
				reqFields: toTruthMap('aid', 'uid', 'qsid', 'qid', 'f'),
				specMap: 'classes'
			},
			giveGeneralFeedback: {
				method: 'put',
				secure: 'teacher',
				fields: toTruthMap('aid', 'uid', 'qsid', 'f'),
				reqFields: toTruthMap('aid', 'uid', 'qsid', 'f'),
				specMap: 'classes'
			},
			closeAssignment: {
				method: 'post',
				secure: 'teacher',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					cc: {
						type: 'string',
						required: true
					}
				}
			},
			removeStudentFromAssignment: {
				method: 'put',
				secure: 'teacher',
				spec: {
					aid: {
						type: 'string',
						required: true,
						regexp: REGEXP.UUID_V4
					},
					cc: {
						type: 'string',
						required: true
					},
					suid: {
						type: 'string',
						required: true
					},
					token: {
						type: 'string'
					}
				}
			},
			updateGCASubmissionId: {
				method: 'get',
				secure: 'student',
				spec: {
					aid: {
						type: 'string',
						required: true
					},
					iid: {
						type: 'string',
						required: true
					},
					token: {
						type: 'string',
						required: true
					}
				}
			}
		},
		account: {
			getSubscriptionStatus: {
				method: 'get',
				secure: 'teacher'
			},
			subscribe: {
				method: 'put',
				secure: 'teacher'
			},
			unsubscribe: {
				method: 'put',
				secure: 'teacher'
			},
			subscribeToSummerReading: {
				method: 'put',
				secure: 'teacher',
				spec: {
					l: {
						type: 'number',
						required: true,
						domain: toTruthMap(9, 10, 11, 12)
					},
					lvl: {
						type: 'string'
					},
					n: {
						type: 'string'
					},
					d: {
						type: 'number',
						required: true
					},
					i: {
						type: 'string',
						required: true
					}
				}
			},
			getJourneys: {
				method: 'get',
				secure: 'teacher'
			},
			updateJourney: {
				method: 'put',
				secure: 'teacher',
				spec: {
					j: {
						type: 'string',
						domain: journeysTruthMap,
						required: true
					},
					idx: {
						type: 'number'
					},
					c: {
						type: 'boolean'
					}
				}
			},
			getGoogleClassroomAuthURL: {
				method: 'get',
				secure: 'teacher'
			},
			googleClassroomAuthReturn: {
				method: 'get',
				secure: false,
				spec: {
					state: {
						type: 'string'
					},
					error: {
						type: 'string'
					},
					code: {
						type: 'string'
					},
					scope: {
						type: 'string'
					},
					authuser: {
						type: 'number'
					},
					hd: {
						type: 'string'
					},
					prompt: {
						type: 'string'
					}
				}
			},
			enableStudentAccount: {
				method: 'put',
				secure: 'teacher',
				spec: {
					uid: {
						type: 'string',
						required: true
					}
				}
			},
			sendAccountVerificationToken: {
				method: 'post',
				secure: 'teacher'
			},
			confirmAccountVerificationToken: {
				method: 'get',
				secure: false,
				spec: {
					token: {
						type: 'string',
						required: true
					},
					uid: {
						type: 'string',
						required: true
					}
				}
			},
			teacherChangeUsername: {
				method: 'post',
				secure: 'teacher',
				fields: toTruthMap('e'),
				reqFields: toTruthMap('e'),
				specMap: 'user'
			},
			teacherGetAccount: {
				method: 'get',
				secure: 'teacher'
			},
			teacherCreateAccount: {
				method: 'post',
				secure: false,
				fields: toTruthMap('e', 'p', 'f', 'l', 'h', 'recaptcha'),
				reqFields: toTruthMap('e', 'p', 'f', 'l'),
				specMap: 'user'
			},
			accountRecovery: {
				method: 'post',
				secure: false,
				reqFields: toTruthMap('e'),
				fields: toTruthMap('e'),
				specMap: 'user',
				rateLimit: {
					limit: 10,
					interval: 10 * 60
				}
			},
			teacherChangeStudentPassword: {
				method: 'post',
				secure: 'teacher',
				reqFields: toTruthMap('u', 'p'),
				fields: toTruthMap('u', 'p'),
				specMap: 'user'
			},
			teacherChangePassword: {
				method: 'post',
				secure: 'teacher',
				reqFields: toTruthMap('p'),
				fields: toTruthMap('p', 'cp'),
				specMap: 'user'
			},
			studentSignInNative: {
				method: 'post',
				secure: false,
				fields: toTruthMap('u', 'p', 'cc'),
				reqFields: toTruthMap('u', 'p', 'cc'),
				specMap: 'student'
			},
			teacherUpdateAccount: {
				method: 'put',
				secure: 'teacher',
				fields: toTruthMap(
					'f',
					'l',
					'r',
					'g',
					'sid',
					'sn',
					'ci',
					'co',
					's',
					'st',
					'k12',
					'print',
					'digital',
					'project',
					'remote',
					'curriculum',
					'ssoSystems'
				),
				specMap: 'user'
			},
			studentChangePassword: {
				method: 'post',
				secure: false,
				reqFields: toTruthMap('p', 'u', 'cp', 'cc'),
				fields: toTruthMap('p', 'u', 'cp', 'cc'),
				specMap: 'student',
				rateLimit: {
					limit: 10,
					interval: 10 * 60,
					keyParam: 'u'
				}
			},
			initializeGoogleUser: {
				method: 'post',
				spec: {
					token: {
						type: 'string',
						required: false
					},
					cc: {
						type: 'string',
						required: true
					},
					gcAddon: {
						type: 'boolean',
						required: false
					}
				}
			},
			initializeCleverUser: {
				method: 'post',
				spec: {
					token: {
						type: 'string',
						required: false
					},
					cc: {
						type: 'string',
						required: true
					}
				}
			},
			revokeToken: {
				method: 'post',
				fields: toTruthMap('token'),
				reqFields: toTruthMap('token'),
				specMap: 'classes'
			},
			createTeacherRosteredStudents: {
				method: 'post',
				secure: 'teacher',
				fields: toTruthMap('cc', 'students'),
				reqFields: toTruthMap('cc', 'students'),
				specMap: 'student'
			},
			teacherUpdateStudentAccount: {
				method: 'post',
				secure: 'teacher',
				reqFields: toTruthMap('u'),
				fields: toTruthMap('u', 'f', 'l', 'ell'),
				specMap: 'student'
			},
			teacherSignIn: {
				method: 'post',
				secure: false,
				rateLimit: {
					limit: 10,
					interval: 10 * 60,
					keyParam: 'e',
					onError: true
				},
				spec: {
					e: {
						type: 'string',
						required: true
					},
					p: {
						type: 'string',
						required: true
					},
					f: {
						type: 'string'
					},
					l: {
						type: 'string'
					}
				}
			},
			accountRecoveryCheck: {
				method: 'put',
				secure: false,
				reqFields: toTruthMap('t'),
				fields: toTruthMap('t'),
				specMap: 'user'
			},
			getMilestones: {
				method: 'get',
				secure: 'teacher'
			},
			updateMilestone: {
				method: 'put',
				secure: 'teacher',
				spec: {
					milestone: {
						type: 'string',
						required: true,
						domain: toTruthMap(
							'findContentEntry',
							'assignmentListEntry',
							'teacherGuideEntry',
							'productPreviewByType',
							'ellFilter',
							'aadPPA',
							'passagePPAByGrade'
						)
					},
					value: {
						type: 'string'
					},
					reset: {
						type: 'boolean'
					}
				}
			}
		}
	}
};
